import React from "react";
import HighlightedText from "../../../../components/HighlightKeyword";

export default function DRBillsGazettedBillsNamePublication({
  documentList,
  openModal,
  query,
  handleSortDocument,
  handleSortBills,
  getArrowIcon,
}) {
  const getEnactedAsValue = (egDocument) => {
    const customAttributeValues =
      egDocument?.egDocumentDto?.egCustomAttributeValue;

    if (!customAttributeValues) {
      console.error("customAttributeValues is undefined:", egDocument);
      return null;
    }
    const result = customAttributeValues?.find(
      (item) => item?.attributeID?.attributeID === 253 || item?.attributeID?.attributeID === 255
    )?.value;
    return result;
  };

  const getFirstReadingDate = (egCustomAttributeValue) => {
    const targetValue = egCustomAttributeValue?.find(
      (item) => item?.attributeID?.attributeID === 254 || item?.attributeID?.attributeID === 256
    )?.value;

    return targetValue;
  };

  return (
    <table className="case-law-table">
      <thead>
        <tr>
          <th style={{ width: "10%" }}>
            <div
              className="case-law-table-header"
              onClick={() => handleSortDocument("actNo")}
            >
              DR {getArrowIcon("actNo")}
            </div>
          </th>
          <th style={{ width: "20%" }}>
            <div
              className="case-law-table-header"
              onClick={() => handleSortBills("no")}
            >
              Bills Gazetted as Act {getArrowIcon("no")}
            </div>
          </th>
          <th style={{ minWidth: "20vw" }}>
            <div
              className="case-law-table-header"
              onClick={() => handleSortDocument("actTitleBI")}
            >
              Bills Name {getArrowIcon("actTitleBI")}
            </div>
          </th>
          <th style={{ width: "20%" }}>
            <div
              className="case-law-table-header"
              onClick={() => handleSortDocument("publicationDate")}
            >
              Publication {getArrowIcon("publicationDate")}
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        {documentList?.map((item) => (
          <tr key={item?.documentId}>
            <td>
              {item?.egDocumentDto?.actNo}/{item?.egDocumentDto?.actYear}
            </td>
            <td style={{ textAlign: "center" }}>{getEnactedAsValue(item)}</td>
            <td>
              <div className="egTitle-title">
                <HighlightedText
                  paragraph={
                    item?.egDocumentDto?.actTitleBI
                      ? item?.egDocumentDto?.actTitleBI
                      : item?.egDocumentDto?.actTitleBM
                  }
                  keyword={query}
                  onClick={() => {
                    openModal(item?.documentBlobDto?.fileUUID);
                  }}
                />
              </div>
              <div style={{ display: "flex", gap: "5px" }}>
                <p>
                  <strong> 1st Reading Date: </strong>
                </p>
                <p style={{ color: "red" }}>
                  {getFirstReadingDate(
                    item?.egDocumentDto?.egCustomAttributeValue
                  )}
                </p>
              </div>
            </td>
            <td style={{ textAlign: "center" }}>
              {new Date(item?.egDocumentDto?.publicationDate).toLocaleDateString(
                "en-GB",
                {
                  day: "2-digit",
                  month: "2-digit",
                  year: "numeric",
                }
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
